import { TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { Category } from "../state/types"
import { DataType } from "../../../tables/types/types"
import { useSystemStateHooks } from "../../system"
import { useProductPricesActions } from "./productPricesActions"
import { useLotsActions } from "./lotsActions"
import { useDataTypeFileActions } from "../../../features/data-types"

export const useProductsActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const productPricesActions = useProductPricesActions()
    const lotsActions = useLotsActions()
    const dataTypeFileActions = useDataTypeFileActions()

    return (paramCompanyId?: string) => {
        const companyId = define(paramCompanyId || stateCompanyId)
        const { fetchAllProductPrices, saveProductPrices, removeProductPrices } = productPricesActions(companyId)
        const { fetchAllLots, saveLot, removeLot } = lotsActions(companyId)
    
        const saveCategory = (
            category: Category,
            imageFile?: File
        ) => {
            const { saveWithImage } = dataTypeFileActions(define(companyId))
            return saveWithImage(TableName.CATEGORIES, category, 'imageUrl' as keyof DataType, imageFile)
        }

        const removeCategory = (id: string) => {
            const { removeWithImage } = dataTypeFileActions(define(companyId))
            return removeWithImage(TableName.CATEGORIES, id, 'imageUrl' as keyof DataType)
        }

        return {
            saveCategory,
            removeCategory,
            fetchAllProductPrices,
            saveProductPrices,
            removeProductPrices,
            fetchAllLots,
            saveLot,
            removeLot
        }
    }
}
